import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Global 15s timeout — after coming back from background, any dead
// TCP sockets will fail fast instead of hanging the UI forever.
// Also skip cached bundles: axios will surface a proper error to loadRooms
// so the user sees "refresh failed" instead of an eternal spinner.
axios.defaults.timeout = 15000;

// ============================================================================
// Auto-refresh when a new build ships (fixes "old UI on PWA reopen" issue).
// The service worker broadcasts SW_UPDATED right after it activates a new
// cache version, and also `controllerchange` fires when the new SW takes
// over an existing page. Either signal → hard reload so the user's phone
// picks up the fresh HTML + JS bundle immediately instead of showing the
// pre-update view until they navigate.
// ============================================================================
if ('serviceWorker' in navigator) {
  let reloading = false;
  const doReload = (reason) => {
    if (reloading) return;
    reloading = true;
    console.log('🔄 Reloading page for new build —', reason);
    // Short delay to let the new SW fully take over before reload
    setTimeout(() => { try { window.location.reload(); } catch {} }, 100);
  };

  // Snapshot the SW that was controlling this page at load time. If a NEW
  // controller takes over later (deploy shipped), reload — but NOT on the
  // very first install (when the initial controller was null).
  const initialController = navigator.serviceWorker.controller;

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SW_UPDATED') {
      doReload('SW_UPDATED message');
    }
  });

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (initialController) {
      doReload('controllerchange');
    }
  });
}

// ============================================================================
// Session-35 — fix "back navigation shows old web view" on mobile PWA.
// When the browser restores this page from the bfcache (back/forward cache),
// `pageshow.persisted` is true. In that case the DOM + JS state is a
// snapshot from the past — including any stale layout the PWA was showing.
// Force a soft reload so the current bundle re-mounts every route fresh.
// ============================================================================
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    console.log('🔄 pageshow.persisted=true → reloading to bust bfcache view');
    try { window.location.reload(); } catch {}
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
